// 建筑
import { $post, $get } from '@/utils/http'
import Service from './Service'

// 接口集合
const _url = {
    // 获取建筑列表
    GETBUILDLIST: `/ucenter/v2/projects/getmodule`,
    // 添加建筑
    ADDBUILD: '/ucenter/v2/projects/addmodule',
    // 批量添加建筑
    ADDBUILDLIST: '/ucenter/v2/projects/addmodulelist',
    // 删除建筑
    DETELBUILD: `/ucenter/v2/projects/delmodule`,
    // 修改建筑
    EDITBUILD: '/ucenter/v2/projects/editmodule',
    // 获取房间
    GETHOUSE: `/ucenter/v2/projects/house`,
    // 编辑房间
    EDITHOUSE: `/ucenter/v2/projects/edithouse`,
    // 删除房间
    DETELEHOUSE: `/ucenter/v2/projects/delhouse`,
    // 新增房间
    ADDHOUSE: `/ucenter/v2/projects/addhouse`,
    // 未注册房间信息
    GETNOBINDHOUSE :`ucenter/v2/projects/gethousenobindhousehold`
}

Service.getBuildList = async function (params) {
    let request = {}
    // 项目Id
    request['assigned_project_id'] = Service.getProjectSystemId();
    if (!request['assigned_project_id']) return;
    // 建筑的id 顶层为0
    request['oid'] = params.OID;
    // 	第几页
    request['page_num'] = 1;
    // 	一页几条数据
    request['page_sum'] = 100;

    let data = await $get(_url.GETBUILDLIST, request);
    return Service.handleCommonError(data)
}

Service.addBuild = async function (params) {
    let request = {}
    // 项目Id
    request['assigned_project_id'] = Service.getProjectSystemId();
    if (!request['assigned_project_id']) return;
    // 建筑名
    request['modulename'] = params.modulename;
    // 建筑层级类型名
    request['typename'] = params.typename;
    // 备注
    request['description'] = params.description;
    // 是否最顶层
    request['istopmodule'] = params.istopmodule;
    // 是否最低层
    request['isendpoint'] = params.isendpoint;
    // 所属上一层id
    request['previous'] = params.previous;
    // 下一层的类型json
    request['next'] = params.next;

    let data = await $post(_url.ADDBUILD, request);
    return Service.handleCommonError(data)
}

Service.addBuildList = async function (params) {
    let request = {}
    // 项目Id
    request['assigned_project_id'] = Service.getProjectSystemId();
    if (!request['assigned_project_id']) return;
    // 建筑列表
    request['list'] = JSON.stringify(params.list);
    // 建筑层级类型名
    request['typename'] = params.typename;
    // 是否最顶层
    request['istopmodule'] = params.istopmodule;
    // 是否最低层
    request['isendpoint'] = params.isendpoint;
    // 所属上一层id
    request['previous'] = params.previous;
    // 下一层的类型json
    request['next'] = params.next;

    let data = await $post(_url.ADDBUILDLIST, request);
    return Service.handleCommonError(data)
}

Service.deleteBuild = async function (params) {
    let request = {}
    
    // 建筑ID
    request['oid'] = params.OID;

    let data = await $post(_url.DETELBUILD, request);
    return Service.handleCommonError(data)
}

Service.editeBuild = async function (params) {
    let request = {}
    // 建筑ID
    request['oid'] = params.oid;
    // 建筑名
    request['modulename'] = params.modulename;
	// 层级
	request['building_index'] = params.building_index;
    // 备注
    request['description'] = params.description;

    let data = await $post(_url.EDITBUILD, request);
    return Service.handleCommonError(data)
}

Service.getHouseList = async function (params) {
    let request = {}
    // 项目Id
    request['project_sys_id'] = Service.getProjectSystemId();
    // 建筑ID
    request['building_id'] = params.OID;
	// 建筑ID
	request['building_index'] = params.building_index;
	// 建筑ID
	request['house_name'] = params.house_name;
    let data = await $get(_url.GETHOUSE, request);
    return Service.handleCommonError(data)
}
Service.getNoBindHouseList = async function (params) {
    let request = {}
    // 项目Id
    request['assigned_project_id'] = Service.getProjectSystemId();
    // 建筑ID
    request['oid'] = params.OID;
	// 建筑ID
	//request['building_index'] = params.building_index;
	
    let data = await $get(_url.GETNOBINDHOUSE, request);
    return Service.handleCommonError(data)
}
// 获取为绑定表记的房间     未用
Service.getHouseBindList = async function (params) {
    let request = {}
    // 项目Id
    request['assigned_project_id'] = Service.getProjectSystemId();
    // 建筑ID
    request['oid'] = params.OID;

    // let data = await $post('/ucenter/v2/projects/gethousenobind', request);
    let data = await $get(_url.GETHOUSE, request);
    return Service.handleCommonError(data);
}

Service.addHouse = async function (params) {
    let request = {}
    // 项目Id
    request['assigned_project_id'] = Service.getProjectSystemId();
    if (!request['assigned_project_id']) return;
    // 房间名
    request['housename'] = params.housename;
    // 房间名
    request['description'] = params.description;
    // 所有上层建筑id数组
    request['moduleidlist'] = JSON.stringify(params.moduleidlist);
    // 面积
    request['area'] = params.area;

    let data = await $post(_url.ADDHOUSE, request);
    return Service.handleCommonError(data)
}

Service.deteleHouse = async function (params) {
    let request = {}
    // 房间ID
    request['oid'] = params.oid;

    let data = await $post(_url.DETELEHOUSE, request);
    return Service.handleCommonError(data)
}

Service.editHouse = async function (params) {
    let request = {}
    // 房间Id
    request['oid'] = params.oid;
    // 房间名
    request['housename'] = params.housename;
    // 房间名
    request['description'] = params.description;
    // 面积
    request['area'] = params.area;

    let data = await $post(_url.EDITHOUSE, request);
    return Service.handleCommonError(data)
}

// 根据ID获取房间信息  未用  用于获取房间里面表计读数
Service.getHouseInfo = async function (params) {
    let request = {}
    // 房间ID
    request['oid'] = params.oid;

    let data = await $post('/ucenter/v2/projects/gethousebyid', request);
    return Service.handleCommonError(data)
}

// 根据住户ID获取房间信息
Service.getLesseeHouseList = async function (params) {
    let request = {}
    // 房间ID
    request['householdid'] = params.householdid;

    let data = await $get('/ucenter/v2/projects/gethousebyhouseholdid', request);
    return Service.handleCommonError(data)
}

// 获取住户流水
Service.getBalanceChange = async function (params) {
    let request = {}
	// 房间ID
	request['household_id'] = params.household_id;
	// 开始时间
	request['from'] = params.from;
	// 结束时间
	request['to'] = params.to;
	// 房间ID
	request['page_num'] = params.page_num;
	// 房间ID
	request['page_sum'] = params.page_sum;
	
    let data = await $get('/ucenter/v2/users/household/balancechange', request);
    return Service.handleCommonError(data)
}